function openWindow(url, w = 550, h = 350) {
  const x = window.screen.width / 2 - w / 2;
  const y = window.screen.height / 4 - h / 2;

  window.open(
    url,
    'share',
    `height=${h},width=${w},top=${y},left=${x},toolbar=0,location=0,menubar=0,directories=0,scrollbars=0`
  );
}

class ShareButtonsElement extends HTMLElement {
  connectedCallback() {
    this._updateURLs(window.location.href.replace(/#.+$/, ''));

    this._controller = new AbortController();
    this.addEventListener('click', this._handleClick, { signal: this._controller.signal });
  }

  disconnectedCallback() {
    this._controller?.abort();
  }

  _updateURLs(rawUrl) {
    const url = encodeURIComponent(rawUrl);

    // FIXME: Handle missing metadata more gracefully
    const metaTitle = document.querySelector('meta[property="og:title"]');
    const metaDescription = document.querySelector('meta[property="og:description"]');
    const metaTwitter = document.querySelector('meta[name="twitter:site"]');
    const title = encodeURIComponent(metaTitle?.content ?? '');
    const description = encodeURIComponent(metaDescription?.content ?? '');
    const twitterUsername = encodeURIComponent(metaTwitter?.content.replace('@', '') ?? '');

    const emailBody = `${description}${encodeURIComponent('\n')}${url}`;

    this.querySelectorAll('[data-ref]').forEach((node) => {
      let href = '';
      switch (node.dataset.ref) {
        case 'email':
          href = `mailto:?subject=${title}&body=${emailBody}%0A%0A${url}`;
          break;
        case 'facebook':
          href = `https://www.facebook.com/sharer.php?u=${url}`;
          break;
        case 'linkedin':
          href = `https://www.linkedin.com/shareArticle?mini=true&url=${url}`;
          break;
        case 'twitter':
          href = `https://twitter.com/intent/tweet?text=${title}&url=${url}&via=${twitterUsername}`;
          break;
        case 'whatsapp':
          href = `https://wa.me/?text=${url}`;
          break;
      }
      node.setAttribute('href', href);
    });
  }

  _handleClick = (e) => {
    const anchor = e.target.closest('a');

    if (!anchor || anchor.protocol === 'mailto:') return;

    e.preventDefault();
    openWindow(anchor.href);
  };
}

customElements.define('chh-share-buttons', ShareButtonsElement);

export default ShareButtonsElement;
